import React from 'react';
import DOM from 'react-dom';
import createStore from '../app/store/create';
import { Provider } from 'react-redux';
import GetQuotesModal from './containers/GetQuotesModal';
import { fetchCategories } from './actions/category';
import { getLoginInfo } from './actions/user';
import { ThemeProvider } from 'styled-components';
import { Theme } from 'hui/src/styled';

window.GQModal = {
  open: (element, category, location) => {
    const store = createStore(window.__INITIAL_STATE__ || {});
    try {
      store.dispatch(fetchCategories());
      store.dispatch(getLoginInfo());
    } catch (e) {
      console.log(e); // eslint-disable-line
    }
    DOM.render(
      <ThemeProvider theme={Theme}>
        <Provider store={store}>
          <GetQuotesModal
            initialCategory={category || undefined}
            initialLocation={location || undefined}
            close={() => DOM.unmountComponentAtNode(element)}
          />
        </Provider>
      </ThemeProvider>,
      element
    );
  },

  close: element => {
    DOM.unmountComponentAtNode(element);
  }
};
